import { useEffect, useContext } from "react";
import { useSearchboxStore, useActions } from "../../store/searchBoxStore.js";
import { actions as searchActions } from "../../store/actions.js";
import { SearchBoxContext } from "../SearchBoxContext/index.js";
const isDateRangeFetched = (dateRange, fetchedRanges) => {
    const [requestStart, requestEnd] = dateRange;
    return fetchedRanges.some((range) => {
        return range.start <= requestStart && range.end >= requestEnd;
    });
};
export const useFetchFareCalendar = ({ dateRange, enabled = true, segmentIndex = 0 } = {}) => {
    const state = useSearchboxStore();
    const fareCalendar = state.searchbox.fareCalendar;
    const actions = useActions(searchActions);
    const segment = state.searchbox.searchSegments[segmentIndex];
    const { autoCompleteBaseURL } = useContext(SearchBoxContext);
    const originLocation = segment?.from?.find((loc) => loc.type === "CITY" || loc.type === "AIRPORT");
    const destinationLocation = segment?.to?.find((loc) => loc.type === "CITY" || loc.type === "AIRPORT");
    const originCode = originLocation?.code;
    const destinationCode = destinationLocation?.code;
    const dateRangeStart = dateRange?.[0];
    const dateRangeEnd = dateRange?.[1];
    useEffect(() => {
        if (!enabled || !dateRange?.[0] || !dateRange?.[1] || !originLocation || !destinationLocation) {
            return;
        }
        const alreadyFetched = isDateRangeFetched(dateRange, fareCalendar.fetchedRanges);
        if (alreadyFetched) {
            return;
        }
        actions.fareCalendarStart();
        const payload = {
            origin: {
                cityIata: originLocation.type === "CITY" ? originLocation.code : undefined,
                airportIata: originLocation.type === "AIRPORT" ? originLocation.code : undefined
            },
            destination: {
                cityIata: destinationLocation.type === "CITY" ? destinationLocation.code : undefined,
                airportIata: destinationLocation.type === "AIRPORT" ? destinationLocation.code : undefined
            },
            dateRange,
            tripType: state.searchbox.type === "ROUNDTRIP" ? "ROUND_TRIP" : "ONE_WAY",
            filters: {
                cabinClass: state.searchbox.cabinClass
            }
        };
        const apiUrl = autoCompleteBaseURL?.url
            ? `${autoCompleteBaseURL.url}/api/flyAnywhere/fareCalendar`
            : "/api/flyAnywhere/fareCalendar";
        fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload),
            credentials: "include"
        })
            .then((response) => response.json())
            .then((data) => {
            actions.fareCalendarSuccess(data.flights, dateRange, data.legend);
        })
            .catch((error) => {
            actions.fareCalendarError(error.message || "Failed to fetch fare calendar data");
        });
    }, [
        dateRangeStart,
        dateRangeEnd,
        enabled,
        segmentIndex,
        originCode,
        destinationCode,
        actions,
        fareCalendar.fetchedRanges,
        state.searchbox.type,
        state.searchbox.cabinClass,
        autoCompleteBaseURL
    ]);
    return {
        data: fareCalendar.data,
        loading: fareCalendar.loading,
        error: fareCalendar.error,
        legend: fareCalendar.legend
    };
};
